import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useSystemIds() {
  return useQuery({
    queryKey: ['system-ids'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('systems')
        .select('id, code, name');
      
      if (error) throw error;
      
      const fleetone = data.find(s => s.code === 'fleet');
      const noteone = data.find(s => s.code === 'noteone');
      
      return {
        fleetone: fleetone?.id,
        noteone: noteone?.id,
        all: data,
      };
    },
    staleTime: Infinity, // IDs de sistemas não mudam
  });
}
